import { Box, Switch, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

export interface SwitchFieldProps {
  name: string;
  label: string;
  control: any;
  color?: "primary" | "secondary" | "success" | "error" | "warning" | "info";
}

export default function SwitchField({
  name,
  label,
  control,
  color = "primary",
}: SwitchFieldProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Switch
            {...field}
            checked={field.value}
            size="medium"
            color={color}
          />
        )}
      />
    </Box>
  );
}
